<template>
  <div class="contact">
    <mt-header title="选择联系人" class="reftitle">
      <mt-button slot="left" icon="back" @click="goback">返回</mt-button>
      <a @click="backhome()" slot="left" class="backhome">关闭</a>
      <mt-button @click="selcontact()" slot="right">确定</mt-button>
    </mt-header>
    <div class="contactspace"></div>
    <div v-for="(item, index) in list">
      <div class="contact-my-f1">
        <div class="contactflex1">
          <img class="contact-my-user" src="/static/img/contract/signer.png">
        </div>
        <div class="contactflex2 contact-ms" @click="viewContact(item)">
          <span class="contactName">姓名:&nbsp;&nbsp;{{item.name}}</span>
          <span class="contactheight">电话:&nbsp;&nbsp;{{item.mobile}}</span>
          <span class="contactheight">邮箱:&nbsp;&nbsp;{{item.mail}}</span>
        </div>
        <div class="contactflex3">
          <label class="fr">
            <span class="uni-checkbox">
              <input type="checkbox" class="uni-checkbox-input"  @click="seladd(index,item.selected)"> 
              <span class="uni-checkbox-core"></span>
            </span> 
          </label>
        </div>
      </div>
      <hr>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Toast, Actionsheet, Field, Indicator} from 'mint-ui';
  export default {
    data () {
      return {
        list: [],
        cid:this.$route.query.cid,
        signerlist:''
      }
    },
    methods: {
      goback: function () {
        history.go(-1); //后退1页
      },
      seladd: function(index,selected){
        this.list[index].selected = !selected;
        Vue.set(this.list, index, this.list[index])
      },
      selcontact: function () {
        for(var i=0;i<this.list.length;i++){
          if(this.list[i].selected){
            var row = {'name':this.list[i].name,'email':this.list[i].mail,'mobile':this.list[i].mobile};
            this.signerlist.push(row);
          }
        }
        this.$router.push({name: 'addsigner', query:{'signerlist':JSON.stringify(this.signerlist),'cid':this.cid}});
      },
      fetcchMsg: function () {
        var _queryMyContactsyncUrl = domain("_queryMyContactsync");
        var that = this;
        that.$http.post(
          _queryMyContactsyncUrl,
          {emulateJSON: true}
          )
          .then(function (response) {  //接口返回数据
            var code = response.data.code;
            var msg = response.data.msg;
            if (code == '0') {
              that.list = response.data.data.rows;
              that.list.map(function(item,index){
                item.selected = false;
              });
            } else {
              Toast(msg)
            }
          }, function (error) {
            console.log(error)
            Toast(msg)
          }).catch(function (response) {
          console.log(response)
          //Toast("数据获取响应异常.")
        })
      },
      backhome: function () {
        this.$router.push('/main');
      }
    },
    components: {},
    mounted: function () {
      this.fetcchMsg();
      this.signerlist = this.$route.query.signerlist;
      if(this.signerlist != null && this.signerlist != "" && typeof(this.signerlist) != "undefined" && this.signerlist != "[]"){
        this.signerlist = eval(this.signerlist);
      }else{
        this.signerlist = new Array();
      }
    }
  }
</script>
<style>
  .my-approval {
    height: 45px;
    line-height: 45px;
    text-align: center;
    background-color: #f9edd7;
  }
  .my-approval img {
    width: 14px;
    margin: 15px 15px 0 0;
  }
  .my-approval a {
    color: #1f74d8;
  }
  .my-approval span {
    color: #997a3d;
  }
  .my-approval a, .my-approval span {
    font-size: 1rem;
  }
  .contact-my-f1 {
    background-color: #ffffff;
    padding: 0 10px 10px 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
  .contactflex1{
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    text-align: center;
  }
  .contactflex2{
    -webkit-box-flex: 3;
    -ms-flex: 3;
    flex: 3;
    text-align: left;
  }
  .contactflex3{
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    text-align: right;
  }
  .contact-my-user {
    width: 40px;
    margin: 15px 0 0 0;
  }
  .contact-my-f1 .contact-ms {
    margin-top: 12px;
    font-size: 0.9rem;
    color: #7d7d7d;
  }
  .contact-delete {
    width: 18px;
    margin: 25px 10px 0 0;
  }
  .contact-my-f1 .rarrow {
    margin: 35px 0 0 0;
  }
  .contactspace {
    width: 100%;
    height: 15px;
    background-color: #f0f0f0;
  }
  .contactheight{
    display: block;
    word-break:break-all;
  }
  .contactName{
    display: block;
    word-break:break-all;
  }

.uni-checkbox-input{
  display: none;
}
.uni-checkbox-core{
  display: inline-block;
  background-color: #fff;
  border-radius: 100%;
  border: 1px solid #ccc;
  width: 18px;
  height: 18px;
  vertical-align: middle;
  position: relative;
  margin-top: 30px;
}

.uni-checkbox-core::after {
  border: 2px solid transparent;
  border-left: 0;
  border-top: 0;
  content: " ";
  top: 3px;
  left: 6px;
  position: absolute;
  width: 4px;
  height: 8px;
  -webkit-transform: rotate(45deg) scale(0);
  transform: rotate(45deg) scale(0);
  -webkit-transition: -webkit-transform .2s;
  transition: -webkit-transform .2s;
  transition: transform .2s;
  transition: transform .2s, -webkit-transform .2s;
}
.uni-checkbox-input:checked + .uni-checkbox-core {
    background-color: #26a2ff;
    border-color: #26a2ff;
}
.uni-checkbox-input:checked + .uni-checkbox-core::after {
    border-color: #fff;
    -webkit-transform: rotate(45deg) scale(1);
    transform: rotate(45deg) scale(1);
}
</style>



// WEBPACK FOOTER //
// src/module/my/Fromcontact.vue